module.exports = __webpack_public_path__ + "01_face.39990292.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/01_face.png
// module id = L9N2
// module chunks = 0